import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

function FileDropZone(props){
    const onDrop = useCallback((acceptedFiles) => {
      // Handle the files here
      props.handleLoadFiles(acceptedFiles)
    }, []);
  
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  
    return (
      <div {...getRootProps()} style={styles.dropzone}>
        <input {...getInputProps()} />
        {
          isDragActive ?
            <p style={{fontSize:'14px', color:'var(--aixelo-green)'}}>{props.showTextOnActive}</p> :
            <p style={{fontSize:'14px', color:'var(--aixelo-green)'}}>{props.showText}</p>
        }
      </div>
    );
  };
  
  const styles = {
    dropzone: {
      border: '2px dashed var(--aixelo-green)',
      borderRadius: '5px',
      padding: '20px',
      textAlign: 'center',
      cursor: 'pointer'
    }
  };
  
  export default FileDropZone;